import Chip from '@mui/material/Chip';
import Tooltip from '@mui/material/Tooltip';
import SyncIcon from '@mui/icons-material/Sync';
import { useCompanyStore } from '../../stores/companyStore';

/** Relative "synced X ago" in Hebrew, computed locally (no dayjs plugin). */
function relTime(iso: string): string {
  const diffMs = Date.now() - new Date(iso).getTime();
  if (Number.isNaN(diffMs)) return '';
  const min = Math.floor(diffMs / 60_000);
  if (min < 1) return 'עכשיו';
  if (min < 60) return `לפני ${min} דק׳`;
  const hr = Math.floor(min / 60);
  if (hr < 24) return `לפני ${hr} שע׳`;
  const days = Math.floor(hr / 24);
  if (days < 30) return `לפני ${days} ימים`;
  const months = Math.floor(days / 30);
  return `לפני ${months} חוד׳`;
}

/**
 * A small "data freshness" cue in the header: when was the active company
 * last synced from Hashavshevet. A trust signal for an audit tool — the
 * auditor sees at a glance whether they're looking at current numbers.
 * Renders nothing until a company with a sync timestamp is selected.
 */
export default function DataFreshness() {
  const selectedId = useCompanyStore((s) => s.selectedCompanyId);
  const companies = useCompanyStore((s) => s.companies);
  const company = companies.find((c) => c.id === selectedId);
  const syncedAt = company?.last_sync_at;
  if (!syncedAt) return null;

  return (
    <Tooltip title={`סונכרן מחשבשבת: ${new Date(syncedAt).toLocaleString('he-IL')}`}>
      <Chip
        size="small"
        icon={<SyncIcon sx={{ fontSize: 14 }} />}
        label={`סונכרן ${relTime(syncedAt)}`}
        variant="outlined"
        sx={{
          color: 'text.secondary',
          borderColor: 'divider',
          fontWeight: 500,
          '& .MuiChip-icon': { color: 'text.disabled' },
        }}
      />
    </Tooltip>
  );
}
